import { render, staticRenderFns } from "./authForm.vue?vue&type=template&id=9c66dd28&scoped=true&"
import script from "./authForm.vue?vue&type=script&lang=js&"
export * from "./authForm.vue?vue&type=script&lang=js&"
import style0 from "./authForm.vue?vue&type=style&index=0&id=9c66dd28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c66dd28",
  null
  
)

export default component.exports